
import {format, formatISO, parseISO} from "date-fns";
import React, {EventHandler, useEffect} from 'react';
import { useState } from 'react';
import {Button, FormControl, getTextFieldUtilityClass, InputLabel, Popover, styled, TextField} from "@mui/material";
import {CalendarPicker, DatePicker} from "@mui/x-date-pickers";
import {isoDateToMMM} from "../utils";
import ClearIcon from '@mui/icons-material/Clear';
import {getTextInsertion} from "slate-react/dist/components/android/diff-text";
interface IsoDatePickerProps {
    value?:string,
    name:string,
    error?:any,
    mondayOnly?:boolean,
    sundayOnly?:boolean,
    readOnly?:boolean,
    onChange:EventHandler<any>,
    fill?:boolean,
    autoFocus?:boolean
    label?:string,
    className?:string,
    allowBlank?:boolean
    readOnlyMode?: 'plain' | 'field';
    style?: any;
}

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    onClick: EventHandler<any>;
}
const ButtonCustom = React.forwardRef<
    any, any
    >(function Ref(props:{
    name: string,
    onChange: EventHandler<any>,
    onClick: EventHandler<any>,
    onBlur?: EventHandler<any>,
    onFocus?: EventHandler<any>,
    autoFocus?: boolean,
    className?: string,
    loading?:boolean,
    readOnly?: boolean
    variant?:"text"|"outlined"|"contained"
    value?: any
},ref) {
    const doClick = (value)=>{
        if(props.onClick) {
            props.onClick({target: {name: props.name, value: value}});
        }
    }
    console.log('args are',props);
    return <Button
        variant={props.variant}
        ref={ref}
        className={props.className}
        onFocus={props.onFocus}
        autoFocus={props.autoFocus}
        onBlur={props.onBlur}
        onClick={doClick}
    >{props.value&&!isNaN(props.value)?format(props.value,'dd MMM yyyy'):'None'}</Button>;
});


const DateButton = (props):React.ReactElement => {
    return <Button {...props}>{props.value}</Button>;
}


// variant of date picker that displays the date as dd/MMM/YYYY after nightbook announcement
// also does not allow direct editing of the string


export const IsoDatePicker = (props:IsoDatePickerProps):React.ReactElement => {
    let value = props.value?parseISO(props.value):null;
    const buttonRef = React.useRef();
    console.log('buttonRef is',buttonRef);
    const [isOpen,setIsOpen] = useState(props.autoFocus?buttonRef.current:null);
    const toggleIsOpen = ()=>{
        setIsOpen((v)=>!v?buttonRef?.current:null);
    }
    useEffect(()=>{
        if(buttonRef?.current && props.autoFocus) {
            setIsOpen(buttonRef?.current);
        }
    },[buttonRef])
    //const field = <Button icon="calendar" intent={props.error?'danger':'none'} onFocus={toggleIsOpen} className={props.readOnly?'bp3-ui-text':'bp3-select-button bp3-button'}>{val}</Button>;
    const onChange = (value) => {
        props.onChange({target:{name:props.name,value:value ? formatISO(value, {representation:'date'}):null}});
        setIsOpen(null);
    };
    const valueIsValid = value && !isNaN(value.getTime()) && value!==null;
    if(!valueIsValid) value = null;
    //console.log('renderdate as',value,valueIsValid,isNaN(value));

    let disabledDates = null;
    //console.log('render with',buttonRef.current);
    if(props.mondayOnly) {
        disabledDates = (date)=>date.getDay()!=1;
    }
    if(props.sundayOnly) {
        disabledDates = (date)=>date.getDay()!=0;
    }
    //
    if(props.readOnly) {
        const formatted = isoDateToMMM(props.value);
        const mode = props.readOnlyMode ?? 'plain';
        if (mode === 'plain') {
            return <>{formatted}</>;
        }
        return (
            <TextField
              label={props.label}
              value={formatted}
              className={props.className}
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
              fullWidth={!!props.fill}
            />
        );
    } else {
        const myClass = getTextFieldUtilityClass('root');
        const clearButton = <ClearIcon onClick={() => {
            props.onChange({target: {name: props.name, value: null}})
        }}/>;
        //const InputProps = props.allowBlank ? {endAdornment: clearButton} : null;
        const popover = <Popover open={!!isOpen} anchorEl={buttonRef.current} onClose={() => setIsOpen(null)}
                                 anchorOrigin={{
                                     vertical: 'bottom',
                                     horizontal: 'left',
                                 }}>
            <CalendarPicker date={value} onChange={onChange}
                            shouldDisableDate={disabledDates} autoFocus={true}
                            views={['year','month','day']}
            />
        </Popover>;
        if (!props.label) {
            return (<><Button ref={buttonRef} {...props} style={{textTransform:'none'}}
                              onClick={ toggleIsOpen}>{valueIsValid ? format(value, 'dd MMM yyyy') : 'None'}</Button>{popover}</>);
        }
        return <><TextField ref={buttonRef} InputLabelProps={{shrink: true}}
                            InputProps={{inputComponent: ButtonCustom}} {...props} size="small" value={value}
                            fullWidth={!!props.fill}
                            onClick={toggleIsOpen}/>
            {popover}
        </>;

        return (<FormControl className={(props.className ?? '')} sx={(theme) => ({
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(0.5),
                borderBottom: "1px solid " + theme.palette.divider
            })}>
                <InputLabel shrink={!!value} variant="filled">{props.label}</InputLabel>
                <Button className={myClass} sx={(theme) => ({
                    height: '100%',
                    alignItems: 'flex-end',
                    paddingBottom: 0,
                    fontSize: theme.typography.pxToRem(14)
                })} color="inherit" ref={buttonRef} onClick={(evt) => {
                    toggleIsOpen()
                }}>{valueIsValid? format(value, 'dd MMM yyyy') : ''}</Button>
                {popover}
            </FormControl>
        );
    }
/*
//        return <><TextField ref={buttonRef} InputLabelProps={{shrink:true}} InputProps={{inputComponent:ButtonCustom}} {...props} size="small" value={value} onClick={()=>setIsOpen(true)}/>
//            {popover}
//</>
//            ;
            *.
/*
        return (
            <><FormControl ><InputLabel shrink={true}>Test</InputLabel><Button {...props} variant="outlined" ref={buttonRef} onClick={(evt)=>{toggleIsOpen(evt.currentTarget)}}>{isoDateToMMM(props.value)}</Button></FormControl>
</>);*/

    /*
    renderInput={(inputProps)=>{
        //console.log(inputProps);
        return <Button {...inputProps} ref={inputProps.inputRef} onClick={()=>setIsOpen(true)}>{props.value}</Button>;
    }}*/

    {/*<TextField {...inputProps} label={props.label} size="small" ref={inputProps.inputRef} className={props.className??''}
                                                                                              InputProps={InputProps}
                                                                                            fullWidth={!!props.fill}
                                                                                              onClick={()=>{setIsOpen(true)}}/>}}*/}
/*
        const picker = <DatePicker dayPickerProps={{disabledDays:filters}} onChange={onChange} value={value}
                                   maxDate={parse((today.getFullYear()+10)+'-01-01','yyyy-MM-dd',today)} />
        return <Popover2 onInteraction={onInteraction} hasBackdrop={true} isOpen={isOpen} placement="bottom" content={picker} fill={props.fill}>{field}</Popover2>*/
    /*
    return (
      <DateInput formatDate={(v)=>format(v,"dd/MM/yyyy")} onChange={onChange} value={value} autoFocus={props.autoFocus}
                  name={props.name} popoverProps={{defaultIsOpen:props.autoFocus}}
                  parseDate={(v)=>parse(v,'dd/MM/yyyy',today)}
                  shouldCloseOnSelect={false} onBlur={props.onBlur}
                  disabled={props.readOnly}
                  inputProps={{autoFocus:props.autoFocus,intent:props.error?'danger':'',className:props.loading?'bp3-skeleton':''}}
                  maxDate={parse((today.getFullYear()+10)+'-01-01','yyyy-MM-dd',today)}
                  dayPickerProps={{disabledDays:filters}} fill={props.fill}
      />
    );*/
}
